<template>
  <div id="content-page">
    <div class="container-fluid">
      <div class="row">
        <b-col class="pb-4 d-flex justify-content-between" sm="12">
            <b-button variant="primary" outline size="lg" @click="toggleAddDataSourceModal">
              <i class="fas fa-plus"></i>
              Add data source
            </b-button>

            <b-button variant="outline-danger" outline size="lg" @click="showDeleteAllDataSourcesModal = true">
              <i class="ri-delete-bin-line"></i>
              Delete all sources
            </b-button>
          </b-col>
      </div>
      <div class="row">
        <b-col>
          <iq-card>
            <template v-slot:body>
              <b-table
                hover
                responsive
                :items="dataSources"
                :fields="fields"
                class="mb-0 table-borderless"
                sort-icon-left
              >
                <template #table-busy>
                  <div class="text-center p-4" style="color: var(--iq-primary)">
                    <b-spinner class="align-middle mr-3"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(name)="data">
                  {{ data.item.url }}
                </template>
                <template v-slot:cell(created_at)="data">
                  {{ data.item.created_at | formatDate | notAvailable }}
                </template>
                <template v-slot:cell(action)="data">
                 <b-button
                  @click="toDeleteItem = data.item.id"
                  variant="outline-danger"
                  size="sm"
                >
                  <i class="ri-delete-bin-line m-0"></i>
                </b-button>
                </template>
              </b-table>
            </template>
          </iq-card>
        </b-col>
      </div>
            <b-modal
                  title="Add new data source"
                  id="add-data-source-modal"
                  hide-footer
                  cancel-title="Close"
                >
                  <FormulateForm
                    name="addDataSource"
                    @submit="submitHandler"
                    v-model="formValues"
                    data-cy="add-data-source-form"
                    #default="{ isValid }"
                  >
                    <b-row>
                      <b-col>
                        <b-alert
                          :show="true"
                          variant="primary"
                          class="bg-white"
                        >
                          <div class="iq-alert-text">
                            <p>
                              Set your data source URL and press
                              <strong>Submit data source</strong> button to add data to RAG of your organization.
                            </p>
                          </div>
                        </b-alert>
                      </b-col>
                    </b-row>
                    <b-row class="d-flex align-items-baseline">
                      <b-col sm="12">
                        <b-form-group class="mb-0">
                          <FormulateInput
                            id="url"
                            name="url"
                            type="text"
                            input-class="form-control"
                            data-cy="name-input"
                            :validation="[['matches',/^(https?:\/\/)?([^\s:@]+:[^\s:@]*@)?((?:[A-Za-z0-9\-]+\.)+[A-Za-z]{2,})((\/[^\s]*)?)$/]]"
                            :validation-messages="{ matches: 'Must be valid URL.' }"

                            error-behavior="value"
                            :disabled="isUpdating"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col>
                        <b-button
                          block
                          type="submit"
                          variant="primary"
                          :disabled="!formValues.url || isUpdating || !isValid"
                          data-cy="submit-button"
                          >{{
                            isUpdating
                              ? "Saving data source..."
                              : "Save data source"
                          }}
                          <b-spinner label="Spinning" v-if="isUpdating" style="width: 1rem; height: 1rem;" class="ml-1" size="sm"></b-spinner>
                          </b-button
                        >
                      </b-col>
                    </b-row>
                  </FormulateForm>
                </b-modal>
      <b-modal
        id="delete-data-source-modal"
        :visible="!!toDeleteItem"
        title="Delete data source"
        @hidden="toDeleteItem = null"
      >
      <p>
        Data source
        <strong>{{ toDeleteDataSource ? `${toDeleteDataSource.url}` : null }}</strong>
        will be deleted.
      </p>
      <p>Are you sure?</p>
      <template #modal-footer="{}">
        <b-button size="sm" variant="outline-dark" @click="toDeleteItem = null"
          >Cancel</b-button
        >
        <b-button size="sm" variant="danger" @click="deleteItem(toDeleteItem)"
          >Delete</b-button
        >
      </template>
    </b-modal>
    <b-modal
        id="delete-all-data-sources-modal"
        :visible="showDeleteAllDataSourcesModal"
        title="Delete all data sources"
        @hidden="showDeleteAllDataSourcesModal = false"
      >
      <p>
        All data sources will be deleted from DB and RAG.
      </p>
      <p>Are you sure?</p>
      <template #modal-footer="{}">
        <b-button size="sm" variant="outline-dark" @click="showDeleteAllDataSourcesModal = false"
          >Cancel</b-button
        >
        <b-button size="sm" variant="danger" @click="deleteAllDataSources()"
          >Delete</b-button
        >
      </template>
    </b-modal>
    </div>
  </div>
</template>
<script>
import { core } from "../../config/pluginInit";
import gql from "graphql-tag";
import { getAccountSync } from "../../Utils/account";
import {addToRAG, deleteOrganizationDataFromRAG} from '../../rag';
import { accessToken, parseJwt } from "../../Utils/auth";
const LIST_DATA_SOURCES = gql`
query listDataSources {
  data_sources {
    id
    url
    organization_id
    owner_id
    rag_result
    created_at
  }
}
`;
const ADD_DATA_SOURCE_MUTATION = gql`
mutation addDataSource($url: String!, $ragResult: String!) {
  insert_data_sources_one(
    object: {
      url: $url,
      rag_result: $ragResult
    }
  ){
    id
    url
    rag_result
    created_at
  }
}
`;
const DELETE_DATA_SOURCE_MUTATION = gql`
  mutation deleteDataSource($id: uuid!) {
    delete_data_sources_by_pk(
      id: $id
    ){
      id
    }
  }
`;
const DELETE_DATA_SOURCES_MUTATION = gql`
  mutation deleteAllDataSources($ids: [uuid!]) {
    delete_data_sources(where: {
      id: {
        _in: $ids
      }
    }){
      affected_rows
    }
  }
`;
export default {
  name: "DataSources",
  data() {
    return {
      isUpdating: false,
      isDeleting: false,
      showAddDataSourceModal: false,
      showDeleteAllDataSourcesModal: false,
      userId: getAccountSync()?.userId,
      fields: [
        { key: "url", title: "URL", sortable: true },
        { key: "created_at", title: "created at", sortable: true },
        { key: "rag_result", title: "RAG result", sortable: true },
        // { key: "action", title: "Action", sortable: false }
      ],
      formValues: {
        url: ""
      },
      updateFormValues: {
        url: "",
      },
      toDeleteItem: null,
    };
  },
  apollo: {
    dataSources() {
      return {
        query: LIST_DATA_SOURCES,
        update: data => {
                return data.data_sources
        }
      };
    },
  },
  methods: {
    async submitHandler() {
      this.isUpdating = true;
      try {
        const ragResponse = await addToRAG(this.rootOrganizationId, this.formValues.url);

        await this.$apollo.mutate({
          mutation: ADD_DATA_SOURCE_MUTATION,
          variables: {
            url: this.formValues.url,
            ragResult: ragResponse,
          }
        });
        this.$toast.success(`Data source added`);
        this.$bvModal.hide("add-data-source-modal");
        this.$apollo.queries.dataSources.refetch();
      } catch (error) {
        console.log(error);
        this.$toast.error(`Failed to add data source: ${error.message}`);
      }
      this.isUpdating = false;
    },
    async deleteItem(id){
      try {
        await this.$apollo.mutate({
          mutation: DELETE_DATA_SOURCE_MUTATION,
          variables: {
            id
          }
        });
        this.$toast.success(`Data source deleted`);
        this.$bvModal.hide("delete-data-source-modal");
        this.$apollo.queries.dataSources.refetch();
      } catch (error) {
        console.log(error);
        this.$toast.error(`Failed to delete data source: ${error.message}`);
      }
    },
    async deleteAllDataSources(){
      const dataSourceIds = this.dataSources.map(i => i.id);
      
      this.isDeleting = true;
      try {
        
        await deleteOrganizationDataFromRAG(this.rootOrganizationId);
        await this.$apollo.mutate({
          mutation: DELETE_DATA_SOURCES_MUTATION,
          variables: {
            ids: dataSourceIds,
          }
        });
        this.$apollo.queries.dataSources.refetch();
      } catch (error) {
        console.error(error);
        this.$toast.error(`Failed to delete all sources: ${error.message}`);
      }
      this.showDeleteAllDataSourcesModal = false;
      this.isDeleting = false;
    },
    toggleAddDataSourceModal() {
      this.$bvModal.show("add-data-source-modal");
    },
    toggleDeleteAllDataSources() {
      this.$bvModal.show("delete-all-data-sources-modal");
    },
  },
  computed: {
    toDeleteDataSource() {
      if (!this.toDeleteItem) {
        return null;
      }
      const d = this.dataSources.find(d => d.id === this.toDeleteItem);
      if (!d) {
        return null;
      }
      return d;
    },
    rootOrganizationId(){
      const parsedJWT = parseJwt(accessToken());
      const id = parsedJWT['https://hasura.io/jwt/claims']?.['x-hasura-organization-id']
      return id;
    },
  },
  mounted() {
    core.index();
  }
};
</script>
